// ══════════════════════════════════════════════════════════════
// COMPASS – Board Member constants (US-041)
// ══════════════════════════════════════════════════════════════

/** The backend's code when the company's only active Board Member would be deactivated (409). */
export const LAST_ACTIVE_BOARD_MEMBER_CODE = 'error.company.board-member.last-active';
/** Shown for that refusal, and as the reason the Deactivate action is disabled on the only active Board Member. */
export const LAST_ACTIVE_BOARD_MEMBER_KEY = 'COMPANY.BOARD_MEMBERS.ERRORS.LAST_ACTIVE_BOARD_MEMBER';

/** The backend's code when the company already has a Board Member with that email (409): shown on the email field. */
export const DUPLICATE_BOARD_MEMBER_EMAIL_CODE = 'error.company.board-member.duplicate-email';
